import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, ChevronLeft } from "lucide-react";
import Logo from "@/components/common/Logo";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast, useForgotPassword } from "@/hooks";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();
  const { mutate: forgotPassword } = useForgotPassword({
    onSuccess: () => {
      // TODO: Implémenter l'appel API pour la réinitialisation du mot de passe
      toast({
        title: "Email envoyé",
        description:
          "Les instructions de réinitialisation ont été envoyées à votre adresse email.",
      });
      navigate("/");
    },
    onError: () => {
      toast({
        title: "Une erreur est survenue",
        description:
          "Impossible d'envoyer les instructions. Veuillez réessayer.",
        variant: "destructive",
      });
    },
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    await forgotPassword(email);
    setIsSubmitting(false);
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-6">
      <div className="w-full max-w-md flex flex-col items-center">
        {/* <Link
          to="/login"
          className="self-start flex items-center text-gray-600 mb-8"
        >
          <ChevronLeft size={20} />
          <span>Retour</span>
        </Link> */}

        <div className="mb-12">
          <Logo size="md" />
        </div>

        <h1 className="text-3xl font-bold text-darkBlue-DEFAULT mb-2">
          Mot de passe oublié ?
        </h1>
        <p className="text-gray-500 mb-8 text-center">
          Entrez votre adresse email pour recevoir les instructions de
          réinitialisation
        </p>

        <form onSubmit={handleSubmit} className="w-full">
          <div className="mb-6 w-full">
            <label
              htmlFor="email"
              className="block text-gray-700 font-medium mb-2"
            >
              Adresse Email
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <Mail className="h-5 w-5 text-gray-400" />
              </div>
              <Input
                type="email"
                id="email"
                className="pl-10 h-14 rounded-xl bg-gray-50 border-gray-200"
                placeholder="Entrez votre adresse email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            className="w-full h-14 bg-cleoMed-primary hover:bg-cleoMed-secondary text-white rounded-xl mb-6"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Envoi en cours..." : "Envoyer les instructions"}
          </Button>
        </form>

        <Link
          to="/"
          className="text-cleoMed-primary text-center font-medium mt-4"
        >
          Retour à l'accueil
        </Link>

        <p className="text-gray-400 text-xs mt-8 text-center">
          © 2025 CleoMed Livraison. Tous droits réservés.
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
